import { getStoredRoles, normalizeRole } from "./authSession";
import { ROLE_HOME_PATH, ROLE_PRIORITY } from "../config/accessControl";

export const getDefaultAuthorizedPath = (roles = getStoredRoles()) => {
  const normalized = Array.from(
    new Set((Array.isArray(roles) ? roles : []).map(normalizeRole).filter(Boolean))
  );

  for (const role of ROLE_PRIORITY) {
    if (normalized.includes(normalizeRole(role))) {
      return ROLE_HOME_PATH[role];
    }
  }

  return "/dashboard";
};
